export * from '@lexical/react/LexicalHorizontalRulePlugin'
